<div *ngIf="images" class="position-relative bg-primary py-4 py-lg-5 overflow-hidden keen-slider-main">
    <div class="keen-slider overflow-visible" #sliderRef>
        <div
            class="keen-slider__slide preview-tile d-flex flex-column align-items-center px-4"
            [ngClass]="{'active' : gi === currentSlide}"
            (click)="setCurrentSlide(gi)"
            *ngFor="let pi of images; let gi = index">
            <div class="bg-image shadow">
                <img class="image-as-bg" [src]="pi.url" [appScrset]="pi.url">
                <div class="full-screen-trigger" *ngIf="showExpandArrows" (click)="goFullScreen()">
                    <i class="fa fa-fw fa-expand-arrows-alt"></i>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="showNav">
        <svg-icon
            src="assets/images/arrow-right-new.svg" class="arrow-left-new"
            [ngClass]="'arrow arrow--left ' + ( currentSlide === 0 ? 'arrow--disabled' : '')"
            [style.fill]="arrowColour"
            (click)="slider.prev()"
            aria-hidden="true"
            focusable="false">
        </svg-icon>
        <svg-icon
            *ngIf="slider"
            src="assets/images/arrow-right-new.svg" class="arrow-right-new"
            [ngClass]="'arrow arrow--right ' + (slider.details().size - 1 === currentSlide ? 'arrow--disabled' : '')"
            [style.fill]="arrowColour"
            (click)="slider.next()"
            aria-hidden="true"
            focusable="false">
        </svg-icon>
    </ng-container>

    <div *ngIf="showDots && dotHelper.length > 1" class="d-flex justify-content-center pt-4 pt-lg-5">
        <button
            (click)="slider.moveToSlideRelative(i)"
            *ngFor="let slide of dotHelper; let i = index"
            [class]="'dot ' + (i === currentSlide ? 'active' : '')"
        ></button>
    </div>
</div>

<div
    *ngIf="fullScreen"
    class="full-screen-holder"
    [ngStyle]="{'background-image': 'url(' + images[currentSlide].url + ')'}">
    <div class="full-screen-trigger full-screen-trigger--top" (click)="closeFullScreen()">
        <i class="fa fa-fw fa-times"></i>
    </div>
</div>
